import type { IMedication } from '../../../../../interfaces/medication';
import { TableData } from '../../../../../elements/common';
import { NullableFormattedDate } from '../../../../../elements/NullableFormattedDate';
import { isCurrentMedication } from './medications';

interface IMedicationsTableRowProps {
    medication: IMedication;
}

export function MedicationsTableRow(props: IMedicationsTableRowProps) {
    const isCurrentMed = isCurrentMedication(props.medication);

    return (
        <>
            <TableData bold={isCurrentMed}>
                {props.medication.name} {props.medication.quantityValue} {props.medication.quantityDisplayName}
            </TableData>
            <TableData bold={isCurrentMed}>{props.medication.dosageInstruction}</TableData>
            <TableData
                align="right"
                bold={isCurrentMed}
                style={{ whiteSpace: 'nowrap' }}
            >
                <NullableFormattedDate value={props.medication.startDate} />
            </TableData>
            <TableData
                align="right"
                bold={isCurrentMed}
                style={{ whiteSpace: 'nowrap' }}
            >
                <NullableFormattedDate value={props.medication.endDate} />
            </TableData>
        </>
    );
}
